'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';

var Footer = /*#__PURE__*/function (_React$Component) {
  _inherits(Footer, _React$Component);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, _getPrototypeOf(Footer).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var year = new Date().getFullYear().toString();
      var footerClassNames = this.props.isFixed ? "fixed" : "";
      return /*#__PURE__*/_jsx("footer", {
        className: footerClassNames,
        children: /*#__PURE__*/_jsx("div", {
          className: "wsg-container",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "footer.poweredBy",
            options: {
              year: year
            }
          })
        })
      });
    }
  }]);

  return Footer;
}(React.Component);

Footer.propTypes = {
  isFixed: PropTypes.bool
};
export { Footer as default };